import { Empty, Flex, Typography } from "antd"
import React from "react"

const { Text } = Typography

interface ProjectsEmptyProps {
  hasSearch?: boolean
}

export function ProjectsEmpty({ hasSearch }: ProjectsEmptyProps) {
  const content = hasSearch ? (
    <Flex vertical className="text-center py-3">
      <Text type={"secondary"} strong>
        No projects found
      </Text>
      <Text type={"secondary"} className=" mt-1">
        Try searching with different keywords
      </Text>
    </Flex>
  ) : (
    "No projects yet"
  )

  return <Empty description={content} />
}
